module.exports = __webpack_public_path__ + "static/media/MobilePumping.87256b7e.png";